/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */

import { DateTimeString, date } from 'common'
export type __FORCE_MODULE__ = unknown; //We add this line so that even if the file ends up being empty, it will still be recognized as a module without impacting the bundle size.

export class SchoolIncidentSummaryData {
  schIncidentGU?: string;
  incidentID?: string;
  incidentDate?: string;
  incidentTime?: string;
  enteredByGU?: string;
  referredBy?: string;
  referredByName?: string;
  referrerType?: string;
  locations?: string;
  incidentContextCode?: string;
  description?: string;
  alcoholRelated: boolean = false;
  bullyingRelated: boolean = false;
  drugRelated: boolean = false;
  gangRelated: boolean = false;
  hateRelated: boolean = false;
  hazingRelated: boolean = false;
  injuryRelated: boolean = false;
  referLawEnforcement: boolean = false;
  unfounded: boolean = false;
  vapingRelated: boolean = false;
  weaponRelated: boolean = false;
  enableWizardViews: boolean = false;
  enableEditButton: boolean = false;
  violations: Array<ViolationData> = [];
  existingViolations: Array<string> = [];
  newlySelectedViolations: Array<string> = [];
  students: Array<StudentData> = [];
}

export class StudentHallPassRestrictionsData {
  hasData: boolean = false;
  groups: Array<StudentHallPassRestrictionGroupData> = [];
}

export class StudentHallPassesData {
  hasData: boolean = false;
  inProgressPasses: Array<StuHallPassData> = [];
  passes: Array<StuHallPassData> = [];
}

export class StudentHallPassSummaryData {
  dataLoaded: boolean = false;
  countToday?: string;
  countThisWeek?: string;
  countThisMonth?: string;
  countThisSchoolYear?: string;
  hallPassStatus?: string;
  hallPassStatusIcon?: string;
  hallPassStatusIconColor?: string;
  passLimit?: string;
  passLimitIcon?: string;
  passLimitIconColor?: string;
}

export class StudentHallPassStatsData {
  dataLoaded: boolean = false;
  totalPassTime?: string;
  passesOverTimeLimit?: string;
}

export class ViolationData {
  lookupValue?: string;
  lookupDesc?: string;
}

export class StudentData {
  studentKey?: string;
  photo?: string;
  formattedName?: string;
  motivation?: string;
  incidentRoleCode?: string;
  incidentRole?: string;
  roleDescription?: string;
  violations: Array<string> = [];
  interventions: Array<InterventionData> = [];
  dispositions: Array<DispositionData> = [];
}

export class StudentHallPassRestrictionGroupData {
  order: number = 0;
  restrictionGroupCode?: string;
  restrictionGroupName?: string;
  studentRestrictions: Array<StudentHallPassRestrictionData> = [];
}

export class StuHallPassData {
  hallPassGU?: string;
  dateTime?: string;
  totalMinutes: number = 0;
  totalTime?: string;
  overTimeLimit: boolean = false;
  inProgress: boolean = false;
  room: HallPassRoomData = new HallPassRoomData;
}

export class InterventionData {
  interventionGU?: string;
  intervention?: string;
  comment?: string;
}

export class DispositionData {
  dispositionKey?: string;
  disposition?: string;
  violationDesc?: string;
  dispositionDesc?: string;
  dispositionDate?: string;
  dispositionHours?: string;
  dispositionDays?: string;
  dispositionComment?: string;
}

export class StudentHallPassRestrictionData {
  studentName?: string;
  studentPhoto?: string;
}

export class HallPassRoomData {
  roomName?: string;
  color?: string;
  colorLight?: string;
  iconPath?: string;
}
